import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RolesSharedService } from '../../services/roles-shared.service';
import { ServiceProvidersService } from '../../services/service-providers.service';

@Component({
  selector: 'app-analyst-search',
  templateUrl: './analyst-search.component.html',
  styleUrls: ['./analyst-search.component.css']
})
export class AnalystSearchComponent implements OnInit {
  appContentData: any;
  homePageInitData: any;
  searchPlaceholderText: string;
  searchResults: any;
  selector = '.sp-list';
  searchItems: any;
  filter: any = {};

  constructor(
    // private appInitProvider: AppInitProvider,
    private serviceProvidersService: ServiceProvidersService,
    private router: Router,
    private rolesSharedService: RolesSharedService
  ) {
    // this.homePageInitData = this.appInitProvider.getAppMetaData();
    // this.appContentData = AppConstant.appContentData;
    // this.searchPlaceholderText = `${this.homePageInitData.searchPH} ${
    //   this.homePageInitData.searchPHServices
    //   } ${this.homePageInitData.searchPHOr} ${
    //   this.homePageInitData.searchPHMarkets
    //   } ${this.homePageInitData.searchPHOr} ${
    //   this.homePageInitData.searchPHSPName
    //   }`;

    // this.appContentData = AppConstant.appContentData;

    this.serviceProvidersService.searchItemObservable.subscribe(
      resp => {
        this.searchItems = resp;
      }
    );
    this.filter.search = "";
    this.rolesSharedService.getNewAnalystListDetails(this.filter).subscribe((data: any) => {
      this.searchResults = data;
    });

  }

  ngOnInit() { }

  onScroll() {
    this.searchItems.offset += this.searchItems.limit;
    this.rolesSharedService.getNewAnalystListDetails(this.searchItems).subscribe(
      resp => {
        this.serviceProvidersService.updateServiceProviders(resp, this.searchItems);
      }
    );
  }

  getAnalystSearchResults(event){
    this.searchResults=event;
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-search/analyst-search.component.ts